import cn from 'classnames';

export function onPageEditing(property) {
    // TODO: Not ready for primetime
    //if((typeof window !== 'undefined' && window.EPiEditMode) || (typeof global !== 'undefined' && global.EPiEditMode)) {
    //}

    if(! property) return null;

    return {
        ["data-epi-property-name"]: property,
        ["data-epi-use-mvc"]: "True"
    };
}

export function filterAttributes(props, match) {
    const newProps = {};

    Object.keys(props).map(prop => {
        if(prop.match(match) && props[prop]) {
            newProps[prop] = props[prop];
        }
    });

    return newProps;
}

export function isTouchDevice() {
    if (typeof document !== 'undefined') {
        return 'ontouchstart' in document.documentElement;
    }

    return false;
}

// https://stackoverflow.com/a/1026087
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function getElementY(query) {
    return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top;
}

export function scrollTo(element, duration) {
    var startingY = window.pageYOffset;
    var elementY = getElementY(element);
    // If element is close to page's bottom then window will scroll only to some position above the element.
    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
    var diff = targetY - startingY;
    // Easing function: easeInOutCubic
    // From: https://gist.github.com/gre/1650294
    var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1; };
    var start;

    if (!diff) return;

    // Bootstrap our animation - it will get called right before next frame shall be rendered.
    window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp;
        // Elapsed miliseconds since start of scrolling.
        var time = timestamp - start;
        // Get percent of completion in range [0, 1].
        var percent = Math.min(time / duration, 1);
        // Apply the easing.
        // It can cause bad-looking slow frames in browser performance tool, so be careful.
        percent = easing(percent);

        window.scrollTo(0, startingY + diff * percent);

        // Proceed with animation as long as we wanted it to.
        if (time < duration) {
            window.requestAnimationFrame(step);
        }
    });
}

export function scrollIntoView(target, element, duration, callback, axisY=true) {
    var params = {
        current: 'scrollTop',
        offset: 'offsetTop'
    };
    if(!axisY){
        params = {
            current: 'scrollLeft',
            offset: 'offsetLeft'
        };
    }
    if(!element){
        console.error("no element?");
        return false;
    }
    var startingAxis = target[params.current];
    var targetAxis = element[params.offset];
    var diff = targetAxis - startingAxis;
    // Easing function: easeInOutCubic
    // From: https://gist.github.com/gre/1650294
    var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1; };
    var start;

    if (!diff) return false;
    // Bootstrap our animation - it will get called right before next frame shall be rendered.
    window.__scrollIntoViewID = window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp;
        // Elapsed miliseconds since start of scrolling.
        var time = timestamp - start;
        // Get percent of completion in range [0, 1].
        var percent = Math.min(time / duration, 1);
        // Apply the easing.
        // It can cause bad-looking slow frames in browser performance tool, so be careful.
        percent = easing(percent);

        if(axisY)
            target.scrollTo(0, startingAxis + diff * percent);
        else
            target.scrollTo(startingAxis + diff * percent, target.scrollTop); // default to current scrollTop

        // Proceed with animation as long as we wanted it to.
        if (time < duration) {
            window.__scrollIntoViewID = window.requestAnimationFrame(step);
        }else{
            if(typeof callback === "function"){
                callback();
            }
        }
    });
    return true;
}

export const debounce = (callback, wait, context = this) => {
    let timeout = null;
    let callbackArgs = null;

    const later = () => {
        callback.apply(context, callbackArgs);
    };

    return function() {
        callbackArgs = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

export const throttle = (callback, wait, context = this) => {
    let timeout = null;
    let callbackArgs = null;

    const later = () => {
        callback.apply(context, callbackArgs);
        timeout = setTimeout(() => {
            timeout = null;
        }, wait);
    };

    return function() {
        if (!timeout) {
            callbackArgs = arguments;
            later();
        }
    };
};

export function groupBy( array , f, sourceArray ){
    var groups = {};
    array.forEach( o => {
        var group = f(o);
        // elements without groups
        if(group === null){
            let groupName = "item_"+o.key;
            groups[groupName] = { ...o };
            return;
        }
        // add object to each group they're a member of
        group.forEach((i) => {
            let source = sourceArray.filter(s => { return i.toString() === s.key.toString();})[0];
            let groupName = "group_"+i;
            groups[groupName] = groups[groupName] || { ...source, items: [] };
            // clone company into group
            groups[groupName].items.push({ ...o });
        });
    });

    return Object.keys(groups).map( group => {
        return groups[group];
    });
}

export function projectIsActive(project) {
    const now = Date.now();
    const { projectStart, projectEnd } = project;
    return now > Date.parse(projectStart) && now < Date.parse(projectEnd);
}

export function markerIcon(project, emphasize = false, title = "Marker") {
    const active = project && projectIsActive(project);

    const alt = project ? project.title : title;

    return require('leaflet').divIcon({
        className: cn({
            ["map-marker"]: !emphasize,
            ["map-marker-active"]: active,
        }),
        iconAnchor: emphasize ? [24, 56] : [9, 9],
        iconSize: emphasize ? [48, 56] : [18, 18],
        popupAnchor: emphasize ? [24, 0] : [0, -27],
        html: emphasize ? `<div><img alt="${alt}" src="${require('assets/markers/project-current.png')}" /></div>` : "<div></div>",
    });
}

export function presentDomain(domain) {
    if(typeof domain !== 'string') return domain;

    domain = domain.replace("http://", "");
    domain = domain.replace("https://", "");
    domain = domain.replace("www.", "");
    domain = domain.split("/");

    return domain[0];
}

export function isAndroidBrowser() {
    if (typeof navigator === "undefined" || !navigator.userAgent) return false;

    const { userAgent } = navigator;

    if (userAgent.indexOf('Android') === -1) return false;
    if (userAgent.indexOf('SamsungBrowser') > -1) return true;

    const chromeRegex = /Chrome\/([\d]+)/;
    const chromeVersion = chromeRegex.exec(userAgent);
    if (chromeVersion && chromeVersion[1] < 58) return true;

    return false;
}

export function addLogoToPrintProjects() {
    const projects = document.querySelectorAll('.project.print')
    for(let i = 0; i < projects.length; i++) {
        const image = new Image(50, 50);
        image.src = require('assets/logo.svg');
        image.style = "width: 50px; height: 50px; margin: 0 0 .5cm; display: block;";
        projects[i].insertBefore(image, projects[i].firstChild);
    }
}

export function GTMTrackingForEpiFormsHandler() {
    var formDataValues = getFormDataValues();
    if (formDataValues && typeof $$epiforms !== 'undefined') {
        $$epiforms(document).ready(function handleFormEvents() {
            $$epiforms(".EPiServerForms").on("formsSubmitted",
                function (event) {
                    handleFormSubmitted(event, formDataValues);
                });
        });
    }
}

function getFormDataValues() {
    var formDataValues = [];

    var hiddenElements = getGTMTrackingHiddenElements();

    if (hiddenElements) {
        for (var i = 0; i < hiddenElements.length; i++) {
            var input = hiddenElements[i];
            if (input) {

                var formGuid = input.form.id;

                for (var j = 0; j < formDataValues.length; j++) {
                    if (formDataValues[j].formGuid === formGuid) {
                        continue;
                    }
                }

                formDataValues.push({
                    formGuid: formGuid
                });
            }
        }
    }

    return formDataValues;
}

function getGTMTrackingHiddenElements() {
    var fieldType = 'GTMTrackingForEpiFormsField';
    var matchingElements = [];

    var allElements = document.getElementsByName(fieldType);
    for (var i = 0, n = allElements.length; i < n; i++) {
        matchingElements.push(allElements[i]);
    }
    return matchingElements;
}

function handleFormSubmitted(event, formDataValues) {
    if (event.isFinalizedSubmission && event.isSuccess && formDataValues) {

        for (var i = 0; i < formDataValues.length; i++) {
            if (formDataValues[i] &&
                formDataValues[i].formGuid === event.delegateTarget.id) {

                var formName = event.workingFormInfo.Name;

                window.dataLayer = window.dataLayer || [];

                var data = {
                    'event': 'form_submit',
                    'form_name': formName
                };

                window.dataLayer.push(data);

                formDataValues.pop(formDataValues[i]);

                break;
            }
        }
    }
}

function checkUserType() {
    if (typeof document !== 'undefined') {
        let touchEndHappened = false;
    
        if (
            !('classList' in document.documentElement) &&
            Object.defineProperty &&
            typeof HTMLElement !== 'undefined'
        ) {
            Object.defineProperty(HTMLElement.prototype, 'classList', {
            get: function() {
                var self = this;
                function update(fn) {
                return function(value) {
                    var classes = self.className.split(/\s+/),
                    index = classes.indexOf(value);
        
                    fn(classes, index, value);
                    self.className = classes.join(' ');
                };
                }
        
                var ret = {
                add: update(function(classes, index, value) {
                    ~index || classes.push(value);
                }),
        
                remove: update(function(classes, index) {
                    ~index && classes.splice(index, 1);
                }),
        
                toggle: update(function(classes, index, value) {
                    ~index ? classes.splice(index, 1) : classes.push(value);
                }),
        
                contains: function(value) {
                    return !!~self.className.split(/\s+/).indexOf(value);
                },
        
                item: function(i) {
                    return self.className.split(/\s+/)[i] || null;
                }
                };
        
                Object.defineProperty(ret, 'length', {
                get: function() {
                    return self.className.split(/\s+/).length;
                }
                });
        
                return ret;
            }
            });
        }
    
        const onMouseDown = () => {
        if (touchEndHappened) {
            return;
        }
    
        document.documentElement.classList.add('mouse-user');
        document.documentElement.classList.add('no-touchevents');
        document.documentElement.classList.remove('touchevents');
        };
    
        const onTouchEnd = () => {
        touchEndHappened = true;
        setTimeout(() => {
            touchEndHappened = false;
        }, 100);
        };
    
        const onTouchStart = () => {
        document.documentElement.classList.add('mouse-user');
        document.documentElement.classList.add('touchevents');
        document.documentElement.classList.remove('no-touchevents');
        };
    
        document.addEventListener('touchstart', onTouchStart);
        document.addEventListener('touchend', onTouchEnd);
        document.addEventListener('mousedown', onMouseDown);
    
        const keyCodeWhiteList = [9, 33, 34, 35, 36, 37, 38, 39, 40];
    
        document.addEventListener('keydown', e => {
        if (keyCodeWhiteList.indexOf(e.which) !== -1) {
            document.documentElement.classList.remove('mouse-user');
        }
        });
    }
  }

  checkUserType();


// WEBPACK FOOTER //
// ./src/utils.js